import _EventService from './EventService';

// eslint-disable-next-line import/prefer-default-export
export const EventService = _EventService;
